import type { FormComponent, FormDSL } from '@commenda/types';
import { walkComponents } from '../dsl-traversal';

export interface EntitySelectOrCreateData {
  fieldId: string;
  entity: string;
  selectedEntityIds: string[];
  template: FormComponent[];
}

/**
 * EntitySelectOrCreate components need special handling because they have
 * multiple entities with template fields. The extractor seeds the static
 * config (entity + template); `selectedEntityIds` is populated from formData
 * later by the integration hook.
 */
export function extractEntitySelectOrCreateComponents(
  dsl: FormDSL
): EntitySelectOrCreateData[] {
  const components: EntitySelectOrCreateData[] = [];
  walkComponents(dsl, (component) => {
    if (component.component === 'EntitySelectOrCreate' && component.fieldId) {
      const props = component.props as { entity?: string } | undefined;
      components.push({
        fieldId: component.fieldId,
        entity: props?.entity || 'corporation',
        selectedEntityIds: [], // populated from formData
        template: component.template || [],
      });
    }
  });
  return components;
}
